import { useMemo, useRef, useState } from "react";
import { IOrderDetails } from "../../../../../models/IOrder";

import { ButtonStyled, InvoiceWrapper } from "./styles";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Loader } from "../../../../../components/loader";
import { updateOrderFileUpload} from "../../../../../services/manager/admin/orders.service";
import { classNames } from "primereact/utils";

interface IFileOrderHandler {
	order: IOrderDetails;
	field: string;
	orderField: any;
	errors: boolean;
}

export const FileOrderHandler: React.FC<IFileOrderHandler> = ({ order, field, orderField, errors }) => {
	const [file, setFile] = useState(orderField);
	const [uploading, setUploading] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleAddFile = () => {
		if (inputRef.current) inputRef.current.click();
	};

	const handleInputFileChange = (event: any) => {
		if (inputRef.current) {
			if (inputRef.current.files) {
				setUploading(true);

				updateOrderFileUpload(order.id, field, inputRef.current.files[0])
					.then((response) => {
						setFile(response[field]);
					})
					.finally(() => {
						setUploading(false);
					});
			}
		}
	};

	const handleDeleteFile = () => {
		updateOrderFileUpload(order.id, field, "").then((response) => {
			setFile(``);
			if (inputRef.current) inputRef.current.value = ``;
		});
	};

	const formatFileName = (name: string): string => {
		if (name?.length > 0) {
			return name.substring(0, 20) + (name.length > 20 ? "..." : "");
		} else {
			return "";
		}
	};

	const fileName = useMemo(
		() => (file ? file.split("/").pop() : ""),
		[file]
	);

	return (
		<InvoiceWrapper>
			{file ? (
				<div className="has-invoice">
					{fileName && fileName.length > 20 ? (
						<OverlayTrigger overlay={<Tooltip>{fileName}</Tooltip>}>
							<a target="_blank" rel="noreferrer" href={file}>
								{formatFileName(fileName)}
							</a>
						</OverlayTrigger>
					) : (
						<a target="_blank" rel="noreferrer" href={file}>
							{fileName}
						</a>
					)}

					{uploading ? (
						<Loader></Loader>
					) : (
						<OverlayTrigger
							overlay={<Tooltip>Remover</Tooltip>}
							placement="top"
						>
							<Button
								variant="link"
								onClick={handleDeleteFile}
							>
								<em className="material-icons-outlined">
									delete
								</em>
							</Button>
						</OverlayTrigger>
					)}
				</div>
			) : (
				<ButtonStyled className={classNames({ 'form-error': errors})} variant="outline-primary" onClick={handleAddFile}>
					Anexar
				</ButtonStyled>
			)}
			<input
				ref={inputRef}
				type="file"
				accept=".pdf"
				onChange={handleInputFileChange}
			></input>
		</InvoiceWrapper>
	);
};
